export const getRowColorClasses = (rating: number) => {
  if (rating >= 8) return { row: 'bg-emerald-50/70', border: 'border-l-4 border-l-emerald-500', sticky: 'bg-emerald-50' };
  if (rating >= 5) return { row: 'bg-green-50/50', border: 'border-l-4 border-l-green-400', sticky: 'bg-green-50' };
  if (rating >= 3) return { row: 'bg-amber-50/40', border: 'border-l-4 border-l-amber-400', sticky: 'bg-amber-50' };
  if (rating >= 1) return { row: 'bg-orange-50/30', border: 'border-l-4 border-l-orange-300', sticky: 'bg-orange-50' };
  return { row: '', border: 'border-l-4 border-l-transparent', sticky: 'bg-background' };
};
